import React__default from 'react';
import { isNamedComponent } from '../../PageLayout/utils.js';
import { validChildren, SVG_MAP } from './constants.js';
import { VisualElementPairWrapper, PairWrapper, SvgWrapper } from './styles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const VisualElementPair = ({
  size = 'lg',
  base,
  pair
}) => {
  const renderComponent = [];
  const visualElements = [{
    component: base,
    size
  }, {
    component: pair,
    size: 'sm'
  }];
  visualElements.map(({
    component,
    size
  }) => {
    const validName = validChildren.find((_, key) => {
      return isNamedComponent(component, validChildren[key]);
    });
    if (validName) {
      if (React__default.isValidElement(component)) {
        renderComponent.push(React__default.cloneElement(component, {
          size
        }));
      }
    } else {
      console.error('VisualElementPair only accepts Visual Element components');
    }
  });
  const [renderBase, renderPair] = renderComponent;
  const borderSize = 2;
  const baseCircle = parseInt(SVG_MAP[size].base.size) / 2;
  const pairCircle = parseInt(SVG_MAP[size].pair.size) / 2 + borderSize;
  const pairPosition = parseInt(SVG_MAP[size].base.size) - 8 + 'px';
  return jsxs(VisualElementPairWrapper, {
    size: size,
    children: [jsx(PairWrapper, {
      children: renderPair
    }), jsxs(SvgWrapper, {
      role: "none",
      children: [jsxs("mask", {
        id: `visual-element-pair-mask-${size}`,
        children: [jsx("circle", {
          fill: "white",
          cx: baseCircle,
          cy: baseCircle,
          r: baseCircle
        }), jsx("circle", {
          fill: "black",
          cx: pairPosition,
          cy: pairPosition,
          r: pairCircle
        })]
      }), jsx("g", {
        mask: `url(#visual-element-pair-mask-${size})`,
        children: jsx("foreignObject", {
          x: "0",
          y: "0",
          height: "100%",
          preserveAspectRatio: "xMidYMid slice",
          width: "100%",
          children: renderBase
        })
      })]
    })]
  });
};
VisualElementPair.displayName = 'VisualElementPair';

export { VisualElementPair };
